<div class="row">
  <div class="form-group col-md-2">
    <div class="form-group">
      <input
        type="range"
        [(ngModel)]="model.years"
        (change)="onChange()"
        name="years"
        class="form-control-range"
        min="0"
        max="25"
        step="1"
      />
    </div>
  </div>
  <div class="form-group col-md-2">
    <label>{{ model.years }} {{ model.years === 1 ? ' Year' : ' Years' }}</label>
  </div>
  <div class="form-group col-md-2">
    <div class="form-group">
      <input
        type="range"
        [(ngModel)]="model.months"
        (change)="onChange()"
        name="months"
        class="form-control-range"
        min="0"
        max="12"
        step="1"
      />
    </div>
  </div>
  <div class="form-group col-md-2">
    <label>{{ model.months }} {{ model.months === 1 ? ' Month' : ' Months' }}</label>
  </div>
  <div class="form-group col-md-2">
    <div class="form-group">
      <input type="range" [(ngModel)]="model.days" (change)="onChange()" name="days" class="form-control-range" min="0" max="30" step="1" />
    </div>
  </div>
  <div class="form-group col-md-2">
    <label>{{ model.days }} {{ model.days === 1 ? ' Day' : ' Days' }}</label>
  </div>
</div>
